import Vanya1 from "./2-3.webp";
import Vanya2 from "./3-3.webp";

const Vanya = [Vanya1, Vanya2];

export default Vanya;
